import { createFileRoute } from '@tanstack/react-router';
import { CreateAeonTrackPage } from '@/page/CreateAeonTrackPage';

export const Route = createFileRoute('/_app/admin/create')({ component: CreateAeonTrackPage });
